// extracted by mini-css-extract-plugin
module.exports = {"viewport":"g1SpUEV9FK2WIMjjvhnxig=="};